export default __webpack_public_path__ + "static/media/just_train.2c5624b9.png";